import "../App.css";

// What this card shows above the fold: a status badge (if any) and whether
// the "Sign Up" CTA appears. Coming Soon tiers never show a CTA — there's no
// checkout flow yet, so the badge alone communicates the state. Exported so
// the viewer-state logic can be unit tested without rendering the DOM.
export function resolveCardState(plan, { authenticated, tier, accessSource }) {
  if (plan.id === "free") {
    if (!authenticated) return { badge: null, showSignUpCta: true };
    return tier === "free"
      ? { badge: "Current Plan", showSignUpCta: false }
      : { badge: null, showSignUpCta: false };
  }

  if (tier === plan.id) {
    return {
      badge: accessSource === "owner_grant" ? "Included with Owner Access" : "Current Plan",
      showSignUpCta: false,
    };
  }

  return plan.comingSoon
    ? { badge: "Coming Soon", showSignUpCta: false }
    : { badge: null, showSignUpCta: false };
}

function formatPrice(plan) {
  if (plan.price === null) return "Coming Soon";
  if (plan.price === 0) return "Free";
  return `$${plan.price}`;
}

export default function PricingCard({ plan, authenticated, tier, accessSource }) {
  const { badge, showSignUpCta } = resolveCardState(plan, { authenticated, tier, accessSource });
  const badgeVariant = badge === "Coming Soon" ? "locked" : plan.id;

  return (
    <div className="plan-card">
      <div className="plan-card-badge-row">
        {badge && <span className={`status-pill status-pill--${badgeVariant}`}>{badge}</span>}
      </div>
      <h3 className="plan-name">{plan.name}</h3>
      <p className="plan-description">{plan.description}</p>
      <div className="plan-price">
        {formatPrice(plan)}
        {plan.price ? <span className="plan-price-interval">/mo</span> : null}
      </div>
      {plan.features.length > 0 && (
        <ul className="plan-feature-list">
          {plan.features.map((feature) => {
            const isComingSoon = typeof feature === "object" && feature.comingSoon;
            const text = isComingSoon ? feature.text : feature;
            return (
              <li key={text} className={`plan-feature${isComingSoon ? " plan-feature--soon" : ""}`}>
                {text}
                {isComingSoon && <span className="plan-feature-soon-tag"> · COMING SOON</span>}
              </li>
            );
          })}
        </ul>
      )}
      {showSignUpCta && (
        <button
          className="fight-btn plan-cta"
          onClick={() => window.dispatchEvent(new CustomEvent("auth:open"))}
        >
          {plan.ctaLabel}
        </button>
      )}
      {plan.footnote && <p className="plan-footnote">{plan.footnote}</p>}
    </div>
  );
}
